<template>
    <v-container mt-3>

        <v-layout row>
            <v-flex xs12 sm6 offset-sm3>

                <p class="body-1">{{this.$t('deleteAccount.enterPassword')}}</p>

                <!-- Sign In                         -->
                <div>
                    <v-form v-model="valid">



                        <v-text-field v-model="password"
                                      :append-icon="show ? 'visibility_off' : 'visibility'"
                                      :type="show ? 'text' : 'password'"
                                      :rules="[rules.required, rules.min]"
                                      @click:append="show = !show"
                                      label="Password"
                                      hint="At least 6 characters"
                                      required></v-text-field>

                    </v-form>

                </div>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 sm6 offset-sm3>
                
                <v-btn small :disabled="!valid" color="error" v-on:click="uiEvent('deleteAccount')">{{this.$t('deleteAccount.deleteAccount')}}</v-btn>
            </v-flex>

        </v-layout>
    </v-container>

</template>

<script>
    const config = require("./../../classes/myConfig").config;
    import firebase from "firebase/compat/app";
    import  * as firebaseAuthPromises from '../../myFirebase/firebaseAuthPromises'; 
    import  * as firebaseFirestore from '../../myFirebase/firebaseFirestore';

    
    export default {
        data() {
            return {
                user : firebase.auth().currentUser,
                snackbarText: "",
                snackbar: false,
                x: null,
                y: "top",
                mode: "",
                timeout: 6000,
                show: false,
                valid: false,
                password: config.getTestPassword(),
                rules: {
                    required: value => !!value || "Required",
                    min: value => (!!value) && ( value.length >= 6 || "Min 6 characters"),
                    
                }
            };
        },
        computed: {},

        methods: {
            uiEvent(event) {
                
                let currentUser = firebase.auth.currentUser;

                // Process events, that do not need store call
                switch (event) {
                    case "cancel": // return to landing page
                        this.$router.push({ name: "Landing" });
                        return;

                    case "deleteAccount":
                        firebaseAuthPromises.deleteAccount(this.password)
                        .then( result => {
                            if (result.code > 0) {
                                this.uxShowSuccess = true;
                                this.$store.commit(
                                    "setSnackbarText",
                                    "Das Konto wurde gelöscht."
                                );
                            /*
                            firebaseFirestore.write_mail("greipl24@dietergreipl.de",
                                "G24: Benutzer gelöscht: " + currentUser.email,
                                " ");
                              */ 

                            } else {
                                this.$store.commit(
                                    "setSnackbarText",
                                    "Konto konnte nicht gelöscht werden."
                                );
                            }
                         });
                        return;
                }

               
            },

            processStoreResult(event, result) {
                console.log("processStoreResult : " + result);
                // Process events, that do not need store call
                let code = result.code;
                switch (event) {
                    case "deleteAccount":
                        if (code > 0) {
                            this.$store.commit("setSnackbarText", "Konto gelöscht");
                            this.$router.push({ name: "landing" });
                            firebaseFirestore.write_mail(
                                "greipl24@dietergreipl.de",
                                "G24 : Konto gelöscht von " + this.user.email,
                                "Diese Testnachricht wurde aus der Adminfunktion on G24 gesendet.");
                        } else {
                            this.$store.commit(
                                "setSnackbarText",
                                "Konto konnte nicht gelöscht werden."
                            );
                        }
                        this.snackbar = true;
                        return;
                }
            }
        }
    };
</script>
